/** @module SiteAdmin/SelectSet/StructureItemsGallery */
define([
	"dojo/_base/declare",
	"csi/gallery/Widget",
	"./_StructureItemsMixin"
], function(declare,GalleryWidget,_StructureItemsMixin) {

	return declare([GalleryWidget,_StructureItemsMixin]);
});